import { createFileRoute, redirect } from '@tanstack/react-router'

import { DigitalProductJourneys } from '@/features/journeys'
import { JourneysListSkeleton } from '@/features/journeys/components/JourneysListSkeleton'
import { journeysEscapeHref } from '@/shared/lib/routing/partnerEntry'

export const Route = createFileRoute('/_event/jornadas/')({
  // Contorno Go!RN: o webview da DoIt abre o app em /jornadas e o evento não
  // executa jornadas. Vale só para a entrada do documento; ver `partnerEntry`.
  beforeLoad: ({ context }) => {
    const href = journeysEscapeHref(context.entryDoor)
    if (href) throw redirect({ href, replace: true })
  },
  // Declarado ao lado do componente que ele representa: rota nova nasce
  // coberta pelo default, e nenhum registro central precisa ser lembrado.
  staticData: { bootSkeleton: JourneysListSkeleton },
  component: DigitalProductJourneysPage
})

function DigitalProductJourneysPage() {
  return <DigitalProductJourneys />
}
